import { useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/AuthProvider';
import { useState, useEffect } from 'react';
import '../css/ProtectedRoute.css';

const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();
    const { isLoggedIn, loading } = useAuth();
    const [showLoading, setShowLoading] = useState(true);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowLoading(false);
        }, 3000);

        const progressTimer = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) return 100;
                return prev + (100 / 30);
            });
        }, 100);

        return () => {
            clearTimeout(timer);
            clearInterval(progressTimer);
        };
    }, []);

    if ((loading || showLoading)) {
        return (
            <div className="loading-container">
                <div className="loading-content">
                    <div className="loading-spinner">
                        <div className="spinner"></div>
                    </div>
                    <div className="loading-text">
                        <h2>Giriş Doğrulanıyor</h2>
                        <p>Sistem güvenlik kontrolü yapılıyor...</p>
                    </div>
                    <div className="loading-progress">
                        <div
                            className="progress-bar"
                            style={{ width: `${progress}%` }}
                        ></div>
                    </div>
                    <div className="loading-percentage">
                        {Math.round(progress)}%
                    </div>
                </div>
            </div>
        );
    }

    if (!isLoggedIn) {
        return navigate(`/login`);
    }

    return children;
};

export default ProtectedRoute;